// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us-container {
  position: relative;
  margin-top: -300px;
  margin-bottom: 100px;
}

.contact-card {
  background: var(--bg-white);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 60px;
  margin: 0 auto;
  /* max-width: 1000px; */
}

/* Left Section - Contact Form */
.contact-form-section {
  padding-right: 40px;
}

.contact-title {
  color: var(--text-primary);
  font-size: var(--font-size-30);
  font-weight: var(--font-bold);
  margin-bottom: 15px;
  font-family: var(--font-codec-cold);
}

.contact-subtitle {
  color: var(--text-black);
  font-size: var(--font-size-medium);
  margin-bottom: 40px;

}

.contact-form {
  width: 100%;
}

.contact-input,
.contact-textarea {
  background-color: var(--text-primary-light) !important;
  border: 1px solid transparent !important;
  border-radius: 8px !important;
  padding: 18px 20px !important;
  font-size: var(--font-size-xsmall) !important;
  transition: all 0.3s ease !important;
}

.contact-input:focus,
.contact-textarea:focus {
  background-color: var(--bg-white) !important;
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 0.2rem rgba(99, 24, 198, 0.25) !important;
  outline: none !important;
}

.contact-input::placeholder,
.contact-textarea::placeholder {
  color: var(--text-black-light-6) !important;
  font-size: var(--font-size-xsmall) !important;
  font-weight: var(--font-regular) !important;
}

.contact-textarea {
  resize: vertical;
  min-height: 170px !important;
}

/* Google reCAPTCHA checkbox — fixed 304x78 iframe, scaled down from JS on narrow screens */
.contact-recaptcha {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.contact-recaptcha-widget {
  width: 304px;
  height: 78px;
  transform-origin: 0 0;
}

.contact-submit-btn {
  background-color: var(--primary-color) !important;
  border: none !important;
  border-radius: 8px !important;
  padding: 18px 40px !important;
  font-size: var(--font-size-18) !important;
  font-weight: var(--font-semibold) !important;
  color: var(--text-white) !important;
  transition: all 0.3s ease !important;
  width: 100%;
  font-family: var(--font-codec-cold);
}

.contact-submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(99, 24, 198, 0.3);
}

.contact-submit-btn:disabled {
  background-color: var(--text-black-light-6) !important;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.contact-submit-btn:disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Alert Messages */
.alert {
  border-radius: 8px;
  padding: 15px 20px;
  font-size: var(--font-size-xsmall);
  font-weight: var(--font-medium);
  border: none;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border-left: 4px solid #28a745;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border-left: 4px solid #dc3545;
}

/* Right Section - Contact Info */
.contact-info-section {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.contact-illustration {
  text-align: center;
  margin-bottom: 40px;
}

.contact-illustration img {
  max-width: 100%;
  height: auto;
}

.contact-details {
  flex-grow: 1;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  /* margin-bottom: 25px; */
  padding: 10px 0 0 0;
  /* background: #F8F5FF; */
  /* border-radius: 15px; */
  /* transition: all 0.3s ease; */
}

/* .contact-item:hover {
  background: #EFE8F9;
  transform: translateX(5px);
} */

.contact-icon {
  flex-shrink: 0;
  margin-right: 10px;
  /* margin-top: 5px; */
}

.icon-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.contact-text a,
.contact-text p {
  margin: 0;
  color: var(--text-secondary);
  font-size: var(--font-size-medium);
  line-height: 1.5;
  font-family: var(--font-codec-cold);
  text-decoration: none;
}

/* Responsive Design */
@media (max-width: 1200px) {

  .contact-us-container {
    margin-bottom: 50px;
  }

  .contact-card {
    padding: 40px 30px;
    margin: 20px;
  }

  .contact-form-section {
    padding-right: 0;
    margin-bottom: 40px;
  }

  .contact-title {
    font-size: var(--font-size-xxlarge);
  }

  .contact-illustration {
    margin-bottom: 30px;
  }
}

@media (max-width: 767px) {
  .comman-gradient-header-minimal {
    min-height: 380px!important;
  }

  .contact-text a,
  .contact-text p {
    font-size: var(--font-size-xsmall);
  }

  .contact-us-container {
    position: relative;
    margin-top: -262px;
    margin-bottom: 50px;
  }

  .comman-gradient-header {
    padding: 40px 0;
  }

  .contact-card {
    padding: 30px 20px;
    margin: 15px;
  }

  .contact-title {
    font-size: var(--font-size-xlarge);
  }

  .contact-subtitle {
    font-size: var(--font-size-xsmall);
  }

  .contact-input,
  .contact-textarea {
    padding: 15px 18px !important;
  }

  .contact-submit-btn {
    padding: 16px 30px !important;
  }

  .contact-item {
    padding: 12px;
  }

  .icon-img {
    width: 35px;
    height: 35px;
  }
}

@media (max-width: 575px) {
  .contact-card {
    padding: 25px 15px;
    margin: 10px;
  }

  .contact-title {
    font-size: var(--font-size-large);
  }

  .contact-form-section {
    margin-bottom: 30px;
  }
}


@media (min-width: 768px) and (max-width: 1024px) {
  .contact-us-container {
    margin-top: -368px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Website/ContactUsPage/ContactUsPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,6BAA6B;EAC7B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;;AAErB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,sDAAsD;EACtD,wCAAwC;EACxC,6BAA6B;EAC7B,6BAA6B;EAC7B,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;;EAEE,4CAA4C;EAC5C,6CAA6C;EAC7C,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA;;EAEE,2CAA2C;EAC3C,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,2FAA2F;AAC3F;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,yCAAyC;EACzC,4CAA4C;EAC5C,mCAAmC;EACnC,oCAAoC;EACpC,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,sDAAsD;EACtD,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;;GAGG;;AAEH;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,4BAA4B;EAC5B,kCAAkC;EAClC,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;;EAEE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;AACF;;;AAGA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".contact-us-container {\n  position: relative;\n  margin-top: -300px;\n  margin-bottom: 100px;\n}\n\n.contact-card {\n  background: var(--bg-white);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 60px;\n  margin: 0 auto;\n  /* max-width: 1000px; */\n}\n\n/* Left Section - Contact Form */\n.contact-form-section {\n  padding-right: 40px;\n}\n\n.contact-title {\n  color: var(--text-primary);\n  font-size: var(--font-size-30);\n  font-weight: var(--font-bold);\n  margin-bottom: 15px;\n  font-family: var(--font-codec-cold);\n}\n\n.contact-subtitle {\n  color: var(--text-black);\n  font-size: var(--font-size-medium);\n  margin-bottom: 40px;\n\n}\n\n.contact-form {\n  width: 100%;\n}\n\n.contact-input,\n.contact-textarea {\n  background-color: var(--text-primary-light) !important;\n  border: 1px solid transparent !important;\n  border-radius: 8px !important;\n  padding: 18px 20px !important;\n  font-size: var(--font-size-xsmall) !important;\n  transition: all 0.3s ease !important;\n}\n\n.contact-input:focus,\n.contact-textarea:focus {\n  background-color: var(--bg-white) !important;\n  border-color: var(--primary-color) !important;\n  box-shadow: 0 0 0 0.2rem rgba(99, 24, 198, 0.25) !important;\n  outline: none !important;\n}\n\n.contact-input::placeholder,\n.contact-textarea::placeholder {\n  color: var(--text-black-light-6) !important;\n  font-size: var(--font-size-xsmall) !important;\n  font-weight: var(--font-regular) !important;\n}\n\n.contact-textarea {\n  resize: vertical;\n  min-height: 170px !important;\n}\n\n/* Google reCAPTCHA checkbox — fixed 304x78 iframe, scaled down from JS on narrow screens */\n.contact-recaptcha {\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.contact-recaptcha-widget {\n  width: 304px;\n  height: 78px;\n  transform-origin: 0 0;\n}\n\n.contact-submit-btn {\n  background-color: var(--primary-color) !important;\n  border: none !important;\n  border-radius: 8px !important;\n  padding: 18px 40px !important;\n  font-size: var(--font-size-18) !important;\n  font-weight: var(--font-semibold) !important;\n  color: var(--text-white) !important;\n  transition: all 0.3s ease !important;\n  width: 100%;\n  font-family: var(--font-codec-cold);\n}\n\n.contact-submit-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 25px rgba(99, 24, 198, 0.3);\n}\n\n.contact-submit-btn:disabled {\n  background-color: var(--text-black-light-6) !important;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.contact-submit-btn:disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n/* Alert Messages */\n.alert {\n  border-radius: 8px;\n  padding: 15px 20px;\n  font-size: var(--font-size-xsmall);\n  font-weight: var(--font-medium);\n  border: none;\n}\n\n.alert-success {\n  background-color: #d4edda;\n  color: #155724;\n  border-left: 4px solid #28a745;\n}\n\n.alert-danger {\n  background-color: #f8d7da;\n  color: #721c24;\n  border-left: 4px solid #dc3545;\n}\n\n/* Right Section - Contact Info */\n.contact-info-section {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.contact-illustration {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.contact-illustration img {\n  max-width: 100%;\n  height: auto;\n}\n\n.contact-details {\n  flex-grow: 1;\n}\n\n.contact-item {\n  display: flex;\n  align-items: flex-start;\n  /* margin-bottom: 25px; */\n  padding: 10px 0 0 0;\n  /* background: #F8F5FF; */\n  /* border-radius: 15px; */\n  /* transition: all 0.3s ease; */\n}\n\n/* .contact-item:hover {\n  background: #EFE8F9;\n  transform: translateX(5px);\n} */\n\n.contact-icon {\n  flex-shrink: 0;\n  margin-right: 10px;\n  /* margin-top: 5px; */\n}\n\n.icon-img {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n}\n\n.contact-text a,\n.contact-text p {\n  margin: 0;\n  color: var(--text-secondary);\n  font-size: var(--font-size-medium);\n  line-height: 1.5;\n  font-family: var(--font-codec-cold);\n  text-decoration: none;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n\n  .contact-us-container {\n    margin-bottom: 50px;\n  }\n\n  .contact-card {\n    padding: 40px 30px;\n    margin: 20px;\n  }\n\n  .contact-form-section {\n    padding-right: 0;\n    margin-bottom: 40px;\n  }\n\n  .contact-title {\n    font-size: var(--font-size-xxlarge);\n  }\n\n  .contact-illustration {\n    margin-bottom: 30px;\n  }\n}\n\n@media (max-width: 767px) {\n  .comman-gradient-header-minimal {\n    min-height: 380px!important;\n  }\n\n  .contact-text a,\n  .contact-text p {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .contact-us-container {\n    position: relative;\n    margin-top: -262px;\n    margin-bottom: 50px;\n  }\n\n  .comman-gradient-header {\n    padding: 40px 0;\n  }\n\n  .contact-card {\n    padding: 30px 20px;\n    margin: 15px;\n  }\n\n  .contact-title {\n    font-size: var(--font-size-xlarge);\n  }\n\n  .contact-subtitle {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .contact-input,\n  .contact-textarea {\n    padding: 15px 18px !important;\n  }\n\n  .contact-submit-btn {\n    padding: 16px 30px !important;\n  }\n\n  .contact-item {\n    padding: 12px;\n  }\n\n  .icon-img {\n    width: 35px;\n    height: 35px;\n  }\n}\n\n@media (max-width: 575px) {\n  .contact-card {\n    padding: 25px 15px;\n    margin: 10px;\n  }\n\n  .contact-title {\n    font-size: var(--font-size-large);\n  }\n\n  .contact-form-section {\n    margin-bottom: 30px;\n  }\n}\n\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .contact-us-container {\n    margin-top: -368px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
